import React from "react";
import { bool, func, shape, number } from "prop-types";
import { Row, Col } from "react-bootstrap";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import ProctoringSubControlSection from "components/ProctoringSubControlSection";

const Proctoring = ({
  handleChangeProctoring,
  isProctoringOptedIn,
  proctoring,
  proctoringConfiguration,
}) => {
  // Handle toggling individual proctoring features
  const handleFeatureToggle = (featureName) => (event) => {
    const updatedConfiguration = {
      ...proctoringConfiguration,
      [featureName]: event.target.checked,
    };

    // We assume handleChangeProctoring can accept a second parameter for the updated configuration
    handleChangeProctoring(event, updatedConfiguration);
  };

  return (
    <>
      <Row>
        <Col lg={10} md={10} sm={10}>
          <h4 className="mb-3">Proctoring</h4>
          <p>
            Increase the security of remote testing with proctoring. Advanced
            features can be enabled below.
          </p>
        </Col>
        <Col lg={2} md={2} sm={2} className="text-right">
          <div className="mx-auto">
            <Toggle
              icons={false}
              id="candidate-proctoring"
              className="global-toggle"
              checked={proctoring}
              onChange={handleChangeProctoring}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12} md={12} sm={12} className="mb-2">
          <ProctoringSubControlSection
            handleFeatureToggle={handleFeatureToggle}
            isProctoringEnabled={proctoring}
            isProctoringOptedIn={isProctoringOptedIn}
            proctoringConfiguration={proctoringConfiguration}
          />
        </Col>
      </Row>
    </>
  );
};

Proctoring.propTypes = {
  handleChangeProctoring: func.isRequired,
  isProctoringOptedIn: number,
  proctoring: bool,
  proctoringConfiguration: shape({
    audioCapture: bool,
    compareSource: bool,
    screenCapture: bool,
    detectMultipleFaces: bool,
    detectFace: bool,
    detectDevice: bool,
  }),
};

export default Proctoring;
